// const CancellationPolicy = () => (
//   <div className="space-y-5">
//     <p>
//       Trek cancellations must be communicated in writing. Refunds depend on the
//       time of cancellation and incurred costs.
//     </p>

//     <ul className="list-disc pl-5 space-y-2">
//       <li>30+ days before departure: refundable (minus service fees)</li>
//       <li>15–29 days before departure: 50% refund</li>
//       <li>Less than 15 days: no refund</li>
//       <li>Permit and flight costs are non-refundable once issued</li>
//     </ul>

//     <p className="text-gray-900 font-medium">
//       Weather delays, natural disasters, or government restrictions are beyond
//       our control and may affect itineraries.
//     </p>
//   </div>
// );

// export default CancellationPolicy;

"use client";

import { AlertTriangle } from "lucide-react";

export default function CancellationPolicy() {
  return (
    <div className="space-y-6 text-gray-700 leading-relaxed">
      <p>
        Trek cancellations must be communicated in writing. Refunds depend on
        the timing of cancellation and costs already incurred.
      </p>

      <ul className="list-disc pl-5 space-y-2">
        <li>30+ days before departure: refundable (minus service fees)</li>
        <li>15–29 days before departure: 50% refund</li>
        <li>Less than 15 days before departure: no refund</li>
        <li>Permit and flight costs are non-refundable once issued</li>
      </ul>

      <div className="flex gap-3 bg-red-50 border border-red-200 p-4 rounded-xl">
        <AlertTriangle className="text-red-600 mt-1" />
        <p className="text-sm text-red-800">
          Weather delays, natural disasters, political unrest, or government
          restrictions are beyond our control and may affect itineraries without
          refund liability.
        </p>
      </div>

      <p className="text-sm text-gray-600">
        We highly recommend comprehensive travel insurance to protect against
        unexpected trip disruptions.
      </p>
    </div>
  );
}
